<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
	<router-view style="width: 100%;height: 100%"></router-view>		<!-- 准备一个路由出口 -->
  </div>
</template>

<script>
// import HelloWorld from './components/HouseView.vue'

export default {
  name: 'app',
  components: {
    // HelloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  /* background-color: blanchedalmond; */
  width: 100%;
  height: 100%;
}
</style>
